// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchBar_searchbar__ez8M1 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.SearchBar_searchbar__ez8M1 .SearchBar_textfield__q\\+HvJ {
  height: 100%;
  border: 0;
}

.SearchBar_searchbar__ez8M1 .SearchBar_button__20XZC {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  width: 20%;
  height: 40px;
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Create/Steppers/Modales/Modal/SearchBar/SearchBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".searchbar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.searchbar .textfield {\n  height: 100%;\n  border: 0;\n}\n\n.searchbar .button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 10px;\n  width: 20%;\n  height: 40px;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchbar": `SearchBar_searchbar__ez8M1`,
	"textfield": `SearchBar_textfield__q+HvJ`,
	"button": `SearchBar_button__20XZC`
};
export default ___CSS_LOADER_EXPORT___;
